<template>
  <v-select outlined hide-details :items="categorias" :value="value" @input="$emit('input', $event)">
    <template #append>
      <mf-icon icon="keyboard_arrow_down" />
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: String,
  },
  computed: {
    categorias() {
      return ['Mensal', 'Anual']
    },
    selectedOption: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      },
    },
  },
}
</script>
